module.exports = __webpack_public_path__ + "static/media/slide-1.228ba8d4.jpg";